(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kaya-product-specifications"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kaya-product-specifications')) {
    customElements.define('kaya-product-specifications', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.closest('.shopify-section')?.addEventListener('change', (event) => {
          const input = event.target;
          if (!(input instanceof HTMLInputElement) && !(input instanceof HTMLSelectElement)) return;
          if (!input.closest('variant-picker')) return;
          const name = (input.dataset.optionName || input.closest('[data-option-name]')?.dataset.optionName || '').toLowerCase();
          const selector = ['maat', 'framemaat', 'frame size'].includes(name)
            ? '[data-frame-size]'
            : ['kleur', 'color', 'colour'].includes(name) ? '[data-selected-color]' : null;
          if (!selector) return;
          const cell = this.querySelector(selector);
          const value = input instanceof HTMLSelectElement
            ? input.selectedOptions[0]?.textContent?.trim()
            : input.value;
          if (cell && value) cell.textContent = value;
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
